import type { NativeEvent } from './sse'

export interface NativeActivityState {
  lifecycle: NativeEvent | null
  tool: string
  thinking: boolean
  busy: boolean
  status: string
}

export function isActiveLifecycle(event: NativeEvent): boolean {
  return event.kind === 'runtime_lifecycle' && (event.phase === 'started' || event.phase === 'active') && event.activity !== 'idle'
}


export function proactiveAssistantTurnId(event: NativeEvent): string | null {
  if (event.kind !== 'runtime_lifecycle' || event.phase !== 'started') return null
  if (event.activity !== 'scheduled_wakeup' && event.activity !== 'idle_nudge') return null
  return typeof event.turn_id === 'string' && event.turn_id ? event.turn_id : null
}

export function terminalLifecycleStatus(event: NativeEvent, currentStatus: string): string {
  if (event.kind !== 'runtime_lifecycle' || isActiveLifecycle(event)) return currentStatus
  return event.state || currentStatus
}

export function nativeActivityLabel(state: NativeActivityState): string {
  const lifecycle = state.lifecycle
  if (lifecycle && isActiveLifecycle(lifecycle)) {
    if (lifecycle.activity === 'forge') return '🔥 Forge 重载中…'
    if (lifecycle.activity === 'resume') return '↩ 恢复中…'
    if (lifecycle.activity === 'dario') return '🫳 保温'
    if (lifecycle.activity === 'scheduled_wakeup') return '⏰ 琥珀醒来了…'
    if (lifecycle.activity === 'idle_nudge') return '🐾 琥珀伸手手…'
  }
  if (state.tool) return `🔧 ${state.tool}`
  if (state.thinking) return '思考中…'
  if (state.busy) return '处理中…'
  if (state.status === 'ready') return '在线'
  return state.status
}
